module.exports = __webpack_public_path__ + "static/img/135931701157217_.pic.297ce47c.jpg";